import { createFileRoute, useRouter } from "@tanstack/react-router";

import Left from "@repo/icons/default/Left";

import { AppointmentTypeAdvancedConfigForm } from "@/components/appointment/type/appointment-type-advanced-config-form";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";

import type { JSX } from "react";

const CreateAppointmentTypeAdvancedConfigPage = (): JSX.Element => {
  const router = useRouter();

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" onClick={() => router.history.back()} />
        <HeaderTitle title="Configurações avançadas" align="center" />
      </HeaderRoot>
      <Page>
        <AppointmentTypeAdvancedConfigForm />
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/create/advanced-config",
)({
  component: CreateAppointmentTypeAdvancedConfigPage,
});
